import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';
import { InventoryItemReportDTO } from '../../inventory/models/item-report-dto';




@Injectable({
  providedIn: 'root'
})
export class InventoryReportService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getInventoryItemsReport(includeInactive: boolean = false, roomId: number = 0) {

    let queryParameters = new HttpParams();

    if (includeInactive !== undefined && includeInactive !== null) {
      queryParameters = queryParameters.set('IncludeInactive', <any>includeInactive);
    }

    if (roomId !== undefined && roomId !== null) {
      queryParameters = queryParameters.set('roomId', <any>roomId);
    }

    return this.httpClient.get<InventoryItemReportDTO[]>(`${this.basePath}/api/inventory/InventoryReports/ItemReport`,
      {
        params: queryParameters
      }
    );
  }

}
